import axios from 'axios';
import { applySort, SORT, useUserCoords } from '../../../../utils/sortListings';
import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SortControl from '../../../common/SortControl';
import { GET_CAR_AGENTS_LIST } from '../../../../Redux/Actions/ActionType';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

export default function CarAgents() {
  const { t } = useTranslation();
  var home = useSelector((state) => state.home);
  const carAgentList = home?.getCarAgentList?.data;
  const dispatch = useDispatch();

  const [sortOption, setSortOption] = useState(SORT.DISTANCE); // [CF 2026-08-02] nearest-first by default
  // [CF 2026-08-02] Only asks the browser for a location when the user
  // actually picks the distance sort; cached for the session after that.
  const userCoords = useUserCoords(sortOption === SORT.DISTANCE);
  const [search, setSearch] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    try {
      // console.log('fetch data part', data);
      axios

        .get(
          `https://api.carsavenue.com/api/carAgent/car`,

          config
        )

        .then((res) => {
          console.log('heeee<<<<', res);
          dispatch({
            type: GET_CAR_AGENTS_LIST,
            payload: res.data.response,
          });

          // setgarageDataDetail(res);

          console.log('heeee<<<<', res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      // Swal.fire('Incorrect Credentials', '', 'error');
    }
  }, []);

  console.log('carAgentList', carAgentList);

  const visibleList = React.useMemo(() => {
    if (!carAgentList) return undefined;
    let list = [...carAgentList];
    const q = search.trim().toLowerCase();
    if (q) {
      list = list.filter((x) =>
        (x?.brand?.name || '').toLowerCase().includes(q)
      );
    }
    list = applySort(list, sortOption, {
      name: (x) => x?.brand?.name,
      coords: userCoords,
    });
    return list;
  }, [carAgentList, sortOption, userCoords, search]);

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-2">{t('Cars Agents')}</h2>

          <div
            className="filter-row mb-4 d-flex align-items-center flex-nowrap"
            style={{ gap: '14px' }}
          >
            {/* Sort By — left */}
            <SortControl value={sortOption} onChange={setSortOption} />

            {/* Search (icon → expands) + result count — fills remaining space on the same row */}
            <div
              className="d-flex align-items-center"
              style={{
                gap: '12px',
                minWidth: 0,
                flex: '1 1 auto',
                justifyContent: 'flex-end',
              }}
            >
              {searchOpen ? (
                <div
                  style={{
                    position: 'relative',
                    flex: '1 1 auto',
                    maxWidth: '460px',
                    minWidth: 0,
                  }}
                >
                  <input
                    type="text"
                    autoFocus
                    className="form-control"
                    placeholder={t('Search by name')}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ paddingInlineEnd: '34px' }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setSearch('');
                      setSearchOpen(false);
                    }}
                    aria-label={t('Clear')}
                    style={{
                      position: 'absolute',
                      insetInlineEnd: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: '20px',
                      lineHeight: 1,
                      color: '#666',
                    }}
                  >
                    &times;
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setSearchOpen(true)}
                  aria-label={t('Search by name')}
                  style={{
                    width: '42px',
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: 'none',
                    borderRadius: '50%',
                    background: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <img src="assets/images/icons/search.png" alt={t('Search by name')} style={{ width: '22px', height: '22px' }} />
                </button>
              )}
            </div>
          </div>

          {visibleList && visibleList.length === 0 ? (
            <p className="text-muted">{t('No results match your search.')}</p>
          ) : (
            <div class="row">
              {visibleList !== undefined &&
                visibleList?.map((data, indx) => {
                  const logo =
                    data?.carMedia?.[0] !== undefined
                      ? data?.carMedia?.[0]?.media?.path
                      : `assets/images/car-brands/mercedes-benz.jpg`;
                  return (
                    <div
                      key={data?.carAgentId || indx}
                      className="col-4 col-sm-4 col-md-4 col-lg-3 mb-4"
                    >
                      <div className="user-car-dealers-block">
                        <Link
                          to={`/user-cars-agents-details/${data?.carAgentId}`}
                        >
                          <div
                            className="line-a"
                            style={{
                              width: '100%',
                              aspectRatio: '1 / 1',
                              overflow: 'hidden',
                              borderRadius: '50%',   // [CF] client: all logos rounded
                              background: '#f4f4f4',
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                              src={logo}
                              alt={data?.brand?.name || ''}
                              loading="lazy"
                              decoding="async"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  'assets/images/car-brands/mercedes-benz.jpg';
                              }}
                            />
                          </div>
                          <div className="line-b"> {data?.brand?.name}</div>
                        </Link>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
